// extracted by mini-css-extract-plugin
module.exports = {"customModalClass":"ModalComponent_customModalClass__3GxCN"};